export const PANELS_BREAKPOINT_PX = 1440;

export const CONTAINER_SIZES_PX = {
    narrow: 448,
    medium: 576,
    wide: 768,
} as const;

export const MD_BREAKPOINT_PX = 768;

export const MD_BREAKPOINT_MEDIA_QUERY = `(min-width: ${MD_BREAKPOINT_PX}px)`;

export const CONTENT_MAX_WIDTH_PX = 900;

export const CARD_GRID_COLUMNS_CLASSES =
    'grid-cols-[repeat(auto-fill,minmax(max(200px,calc((100%_-_2rem)/3)),1fr))]';

export const COMPACT_CARD_GRID_COLUMNS_CLASSES =
    'grid-cols-[repeat(auto-fill,minmax(190px,1fr))]';
